export enum SUBSCRIPTION_STATUS {
    ACTIVE = 'active',
    CANCELLED = 'cancelled',
    ENDED = 'ended',
    FROZEN = 'frozen',
}

export type Subscription = {
    id: string;
    created_at: string;
    modified_at: string;
    reference: string;
    external_id: number | null;
    start_date: string | null;
    end_date: string | null;
    status: SUBSCRIPTION_STATUS;
    cancelled_at: string | null;
    locked_at: string | null;
    stopped_on: string | null;
    has_active_billing: boolean | null;
    service_plan: {
        id: string;
        name: string;
    };
    customer: {
        id: string;
        name: string;
    };
};
